import { getHasUserTeamsAssignment, getHasUsersTeamsAccess, getUser // @ts-expect-error not typed
} from 'EmailData/selectors/user';
// @ts-expect-error not typed
import { getIsProductReadOnly } from 'EmailData/selectors/portalCritsitSelectors';
import { DETAIL_ACTIONS } from 'EmailComponents/utils/actions/detailActionsUtil';
import { trackFrameworkTableInteraction } from 'EmailComponents/utils/tracking';
import { hasComparisonToolAccess } from 'EmailData/selectors/comparisonToolSelectors';
import { canAssignMultipleEmail } from 'EmailData/utils/teams';
import { MARKETING_EMAIL_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
import { DEFAULT_VIEW_PATH, PROPERTIES } from 'email-management-lib/Shared/constants/frameworkTable';
import EmailModel from 'email-management-lib/Shared/models/EmailModel';
import { multiArchive, multiArchiveAndCancel, multiDelete, multiMoveToFolder, multiUnarchive } from 'email-management-lib/refactor/actions/manage/emailActions';
import { selectMultiEmailCrmObjects } from 'email-management-lib/refactor/actions/manage/frameworkTable';
import BulkActions from 'email-management-lib/refactor/components/manage/dashboardTable/BulkActions';
import BulkEdit from 'email-management-lib/refactor/components/manage/frameworkTable/bulkActions/BulkEdit';
import ManageAccessPanel from 'email-management-lib/refactor/components/manage/frameworkTable/components/ManageAccessPanel';
import { isEmailInReview } from 'email-management-lib/refactor/utils/getActions';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { BULK_SELECTION_MODE } from 'framework-listing-lib/constants/table';
import listingLibObserver from 'framework-listing-lib/utils/listingLibObserver';
import cloneDeep from 'hs-lodash/cloneDeep';
import { gate } from 'hub-http/gates';
import { List, Seq } from 'immutable';
import useHasCustomProperties from 'messaging-management-lib/customProperties/hooks/useHasCustomProperties';
import useHasAllGates from 'messaging-management-lib/user/hooks/useHasAllGates';
import Raven from 'raven-js';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AssetCopierPanel, useHasAssetCopierAccess } from 'ui-multi-account-asset-copier';
import BulkArchiveButton from './BulkArchiveButton';
import BulkCompareButton from './BulkCompareButton';
import BulkCopyAssetsButton from './BulkCopyAssetsButton';
import BulkDeleteButton from './BulkDeleteButton';
import BulkManageAccessButton from './BulkManageAccessButton';
import BulkMoveButton from './BulkMoveButton';
import BulkUnarchiveButton from './BulkUnarchiveButton';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export default function BulkActionsHeaderContainer({
  uiMode,
  selectedObjects,
  selectionMode,
  selectedViewPath,
  selectedObjectsCount,
  onClearSelection
}) {
  const dispatch = useDispatch();
  const hasAllGates = useHasAllGates();
  useEffect(() => {
    dispatch(selectMultiEmailCrmObjects(selectedObjects));
  }, [dispatch, selectedObjects]);
  const isUngatedForCustomProperties = useMemo(() => hasAllGates(['CRM:Properties:Email']), [hasAllGates]);
  const isUngatedForBulkManageAccess = useMemo(() => hasAllGates(gate('EmailBulkManageAccess')), [hasAllGates]);
  const hasCustomProperties = useHasCustomProperties({
    objectTypeId: MARKETING_EMAIL_TYPE_ID,
    requiredGates: ['CRM:Properties:Email']
  });
  const [showManageAccessPanel, setShowManageAccessPanel] = useState(false);
  const [selectedBulkAction, setSelectedBulkAction] = useState('');
  useEffect(() => {
    dispatch(selectMultiEmailCrmObjects(selectedObjects));
  }, [dispatch, selectedObjects]);
  const user = useSelector(getUser);
  const hasUsersAndTeamsAccess = useSelector(getHasUsersTeamsAccess);
  const canAssignUsersAndTeams = canAssignMultipleEmail(hasUsersAndTeamsAccess, useSelector(getHasUserTeamsAssignment));
  const comparisonToolAccess = useSelector(hasComparisonToolAccess);
  const isProductReadOnly = useSelector(getIsProductReadOnly);
  const hasBulkWriteAccess = useMemo(() => {
    return user.canWrite() && !isProductReadOnly;
  }, [isProductReadOnly, user]);
  const isAllEmailsInCurrentViewSelected = useMemo(() => selectionMode === BULK_SELECTION_MODE.ALL, [selectionMode]);
  const {
    selectedCrmEmails,
    selectedEmailIds,
    selectedEmailNames,
    selectedCRMObjectIds
  } = useMemo(() => {
    const temp = selectedObjects.reduce((acc, crmObject) => {
      const email = EmailModel.from(crmObject);
      acc.selectedCrmEmails.push(email);
      acc.selectedEmailIds.push(email.id);
      acc.selectedEmailNames.push(email.name);
      acc.selectedCRMObjectIds.push(email.crmObjectId);
      return acc;
    }, {
      selectedCrmEmails: [],
      selectedEmailIds: [],
      selectedEmailNames: [],
      selectedCRMObjectIds: []
    });
    return {
      selectedCrmEmails: List(temp.selectedCrmEmails),
      selectedEmailIds: Seq(temp.selectedEmailIds),
      selectedEmailNames: temp.selectedEmailNames,
      selectedCRMObjectIds: temp.selectedCRMObjectIds
    };
  }, [selectedObjects]);
  const inReviewEmailsCount = useMemo(() => {
    return selectedCrmEmails.count(isEmailInReview);
  }, [selectedCrmEmails]);
  const bulkActionUpdateClientCache = useCallback(() => {
    listingLibObserver.delete(selectedObjects.map(crmObj => crmObj.objectId));
    onClearSelection();
  }, [onClearSelection, selectedObjects]);
  const renderBulkActionsModal = useMemo(() => {
    const onArchive = () => {
      dispatch(multiArchive(selectedEmailIds, true)).then(() => bulkActionUpdateClientCache()).catch(e => Raven.captureException(e));
    };
    const onArchiveCancel = () => {
      dispatch(multiArchiveAndCancel(selectedEmailIds, true)).then(() => bulkActionUpdateClientCache()).catch(e => Raven.captureException(e));
    };
    const onDelete = () => {
      dispatch(multiDelete(selectedEmailIds, true)).then(() => bulkActionUpdateClientCache()).catch(e => Raven.captureException(e));
    };
    const onModalClose = () => setSelectedBulkAction('');
    const onMoveToFolder = (__e, folderId, folderName) => {
      dispatch(multiMoveToFolder({
        selectedEmailIds,
        targetFolderId: folderId,
        selectedEmailNames,
        targetFolderName: folderName,
        isFramework: true
      })).then(() => {
        listingLibObserver.update(selectedObjects.map(object => {
          const result = cloneDeep(object);
          const hsFolderIdProperty = result.properties[PROPERTIES.CONTENT_FOLDER_ID];
          const folderIdString = folderId ? folderId.toString() : '';
          if (hsFolderIdProperty) {
            result.properties[PROPERTIES.CONTENT_FOLDER_ID].value = folderIdString;
          } else {
            result.properties[PROPERTIES.CONTENT_FOLDER_ID] = {
              value: folderIdString
            };
          }
          return result;
        }));
        onClearSelection();
      }).catch(e => Raven.captureException(e));
    };
    const onUnarchive = () => {
      dispatch(multiUnarchive(selectedEmailIds, true)).then(() => bulkActionUpdateClientCache()).catch(e => Raven.captureException(e));
    };
    return /*#__PURE__*/_jsx(BulkActions, {
      currentModal: selectedBulkAction,
      isArchived: selectedViewPath === DEFAULT_VIEW_PATH.ARCHIVED,
      onArchive: onArchive,
      onArchiveCancel: onArchiveCancel,
      onDelete: onDelete,
      onModalClose: onModalClose,
      onMoveToFolder: onMoveToFolder,
      onUnarchive: onUnarchive,
      selected: selectedCrmEmails,
      isFramework: true
    });
  }, [bulkActionUpdateClientCache, dispatch, onClearSelection, selectedBulkAction, selectedCrmEmails, selectedEmailIds, selectedEmailNames, selectedObjects, selectedViewPath]);
  const onClickDeleteButton = useCallback(() => setSelectedBulkAction(DETAIL_ACTIONS.DELETE), []);
  const onClickMoveButton = useCallback(() => {
    setSelectedBulkAction(DETAIL_ACTIONS.MOVE_TO_FOLDER);
  }, []);
  const onClickUnarchiveButton = useCallback(() => {
    if (selectedEmailIds.size === 1) {
      dispatch(multiUnarchive(selectedEmailIds, true)).then(() => bulkActionUpdateClientCache()).catch(e => Raven.captureException(e));
    } else {
      setSelectedBulkAction(DETAIL_ACTIONS.UNARCHIVE);
    }
  }, [bulkActionUpdateClientCache, dispatch, selectedEmailIds]);
  const onClickArchiveButton = useCallback(() => {
    setSelectedBulkAction(DETAIL_ACTIONS.ARCHIVE);
  }, []);
  const onClickManageAccessButton = useCallback(() => {
    trackFrameworkTableInteraction({
      otherActions: 'selectUsersAndTeams-multiple'
    });
    setShowManageAccessPanel(true);
  }, []);
  const {
    hasAssetCopierAccess
  } = useHasAssetCopierAccess();
  const [showCopyToAccountPanel, setShowCopyToAccountPanel] = useState(false);
  const onClickCopyToAccountButton = () => {
    trackFrameworkTableInteraction({
      otherActions: 'copyToAccount-multiple'
    });
    setShowCopyToAccountPanel(true);
  };
  const assetsToCopy = useMemo(() => {
    if (!hasAssetCopierAccess) {
      return [];
    }
    return selectedCrmEmails.map(email => ({
      assetId: email.id,
      assetName: email.name,
      portableType: 'marketing-email',
      metadata: {
        'marketing-email': {
          emailType: email.emailType
        }
      }
    })).toJS();
  }, [selectedCrmEmails, hasAssetCopierAccess]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(TFlex, {
      "data-test-id": "default-bulk-actions",
      gap: 14,
      marginInlineStart: "200",
      children: [!isAllEmailsInCurrentViewSelected && isUngatedForCustomProperties && hasCustomProperties && /*#__PURE__*/_jsx(BulkEdit, {
        selectedIds: selectedCRMObjectIds,
        areAllEmailsSelected: isAllEmailsInCurrentViewSelected,
        clearSelection: onClearSelection
      }), !isAllEmailsInCurrentViewSelected && /*#__PURE__*/_jsx(BulkDeleteButton, {
        hasBulkWriteAccess: hasBulkWriteAccess,
        onClick: onClickDeleteButton,
        selectedCrmEmails: selectedCrmEmails,
        unsafeEmailCount: inReviewEmailsCount,
        user: user
      }), !isAllEmailsInCurrentViewSelected && /*#__PURE__*/_jsx(BulkMoveButton, {
        hasBulkWriteAccess: hasBulkWriteAccess,
        clearSelection: onClearSelection,
        selectedObjectCount: selectedObjectsCount,
        selectedObjects: selectedObjects,
        selectionMode: selectionMode,
        uiMode: uiMode,
        onClick: onClickMoveButton,
        selectedViewPath: selectedViewPath
      }), !isAllEmailsInCurrentViewSelected ? selectedViewPath === DEFAULT_VIEW_PATH.ARCHIVED ? /*#__PURE__*/_jsx(BulkUnarchiveButton, {
        hasBulkWriteAccess: hasBulkWriteAccess,
        onClick: onClickUnarchiveButton
      }) : /*#__PURE__*/_jsx(BulkArchiveButton, {
        hasBulkWriteAccess: hasBulkWriteAccess,
        onClick: onClickArchiveButton,
        unsafeEmailCount: inReviewEmailsCount
      }) : null, (!isAllEmailsInCurrentViewSelected || isUngatedForBulkManageAccess) && /*#__PURE__*/_jsx(BulkManageAccessButton, {
        canAssignUsersAndTeams: canAssignUsersAndTeams,
        isProductReadOnly: isProductReadOnly,
        onClick: onClickManageAccessButton
      }), !isAllEmailsInCurrentViewSelected && /*#__PURE__*/_jsx(BulkCompareButton, {
        hasComparisonToolAccess: comparisonToolAccess,
        selectedEmailIds: selectedEmailIds
      }), !isAllEmailsInCurrentViewSelected && /*#__PURE__*/_jsx(BulkCopyAssetsButton, {
        hasAssetCopierAccess: hasAssetCopierAccess,
        onClick: onClickCopyToAccountButton
      })]
    }), showManageAccessPanel && /*#__PURE__*/_jsx(ManageAccessPanel, {
      crmObjects: selectedObjects,
      hasManageAccessScope: canAssignUsersAndTeams,
      isAssigningAllInCurrentView: isAllEmailsInCurrentViewSelected,
      onClose: () => setShowManageAccessPanel(false),
      onSuccess: response => {
        listingLibObserver.manageAccessSuccess(response);
        onClearSelection();
      },
      totalObjects: selectedObjectsCount
    }), showCopyToAccountPanel && /*#__PURE__*/_jsx(AssetCopierPanel, {
      portableType: "marketing-email",
      onClose: () => setShowCopyToAccountPanel(false),
      assets: assetsToCopy,
      onCopyComplete: () => trackFrameworkTableInteraction({
        otherActions: 'copyToAccount-multiple-success'
      })
    }), renderBulkActionsModal]
  });
}